import * as _ from 'underscore';
import * as ng from 'angular';
import * as nggt from 'angular-gettext';
import * as uir from '@uirouter/angularjs';

import { SiteConfig, Geolocate, Loader } from '../shared';
import { EventListService, EventDetail } from '.';

resolveEventsList.$inject = ['config', 'eventListService'];
export function resolveEventsList(config:SiteConfig, eventListService:EventListService) {
   if (!config.settings.userGateway) {
      return eventListService.list();
   }
}

export class EventSelectController implements ng.IComponentController {
   static $inject = ['$sce', '$state', 'config', 'gettextCatalog', 'geolocate', 'eventListService', 'loader'];

   constructor(
      private $sce:ng.ISCEService,
      private $state:uir.StateService,
      private config:SiteConfig,
      private gettextCatalog:nggt.gettextCatalog,
      private geolocate:Geolocate,
      private eventListService:EventListService,
      private loader:Loader
   ) { }

   events:EventDetail[];

   findEventsByLocation() { 
      this.loader.loading = true;
      this.events = undefined;
      this.geolocate().then((coords) => {
         this.eventListService.list(coords).then(_events => {
            this.events = _events;
         });
      }).catch((e) => {
         this.events = null;
         console.log(`geolocate error: ${e.code}`);
         // GeolocationPositionError, code 1 = User Denied, 2 = Position Unavailable, 3 = Timeout
      }).finally(() => this.loader.loading = false);
   }

   get requireLocation() {
      return this.config.settings.userGateway && (this.events == null || this.events.length == 0);
   }

   get language() {
      return this.gettextCatalog.getCurrentLanguage();
   }

   get titleText() {
      return this.requireLocation && this.config.settings.eventsTitleUserGateway[this.language] ? this.config.settings.eventsTitleUserGateway[this.language] : this.config.settings.eventsTitle[this.language];
   }

   get extraText() {
      let text = this.config.settings.eventsText[this.language];
      if (text) {
         return this.$sce.trustAsHtml(text);
      }
   }

   get showList() {
      return _.contains(['list', 'hybrid'], this.config.settings.eventSelectLayout);
   }

   get showMap() {
      return _.contains(['map', 'hybrid'], this.config.settings.eventSelectLayout);
   }

   onSelect(event:EventDetail) {
      this.$state.go('shell.events.register', { eventId: event.id });
   }
}

ng.module('selfReg').component('eventSelect', {
   templateUrl: require('./event-select.html'),
   controller: EventSelectController,
   bindings: {
      events: '<'
   }
});
